import { FooterConfig } from "@energylab/shared-components/constants/config/footerConfig";

export const footerConfig: FooterConfig = {
    links: ["contact", "faq", "privacy", "disclaimer", "cookyPolicy"],
    enlabUrl: "https://energylab.be/en/",
    enlabLogo: "https://res.cloudinary.com/energylab/image/upload/v1565256948/generic-v2/energylab_horfullcolour_rgb_v2.svg",
    companyLogo: undefined,
    companyName: "Your Best Self"
};
